"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
function debounce(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;

    var timer = false;
    var args = null;
    var context = undefined;

    function proxy() {
        context = this;
        args = arguments;

        if (timer !== false) {
            clearTimeout(timer);
        }

        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };

    proxy.cancel = function () {
        if (timer !== false) {
            clearTimeout(timer);
            timer = false;
            return true;
        }

        return false;
    };

    proxy.force = function () {
        if (this.cancel()) {
            fn.apply(context, args);
        }
    };

    proxy.unwrap = function () {
        return fn;
    };

    return proxy;
}
//# sourceMappingURL=debounce.js.map